import { axiosInstanceV2 } from "@rentablo/api";
import { TransactionsApiListAndSearchAllTransactionV2Request } from "@rentablo/api/apiv1";

export const downloadTransactions = async (
  token: string | undefined,
  params: TransactionsApiListAndSearchAllTransactionV2Request
) => {
  const { data } = await axiosInstanceV2.get<File>(`/transactions`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    responseType: "blob",
    params,
  });
  return data;
};
